module.exports = __webpack_public_path__ + "images/emoji/cocktail.133f76a433d53fe28b90.png";